import React from 'react';

export default function ThemeWrapper({ children }) {
  return (
    <React.Fragment>
      <div>{children}</div>
    </React.Fragment>
  );
}
